import _ from 'lodash'
import { createSelector } from 'reselect'
import { quoteModelRevisionKey } from '@Builder/QuoteDetailPage/selectors'

import {
    quotesList_me_quotes_items_Quote_quoteModels_items as QuoteModelsType,
    quotesList_me_quotes_items_Quote_quoteModels_items_selectedQuoteModelRevision as SelectedQmrType,
} from './QuotesTabs/__generated__/quotesList'

const EMPTY_ARRAY = Object.freeze([])

export const PAGINATION_LIMIT = 4
export const DEFAULT_PAGE_NUMBER = 1
export const DEFAULT_PAGE_OFFSET = 0
export const QUOTE_LIST_SORT_KEY = 'LAST_MODIFIED_DESC'
export const PAGE = 'page'
export const SECURE_PLUS = 'SECURE_PLUS'
export const TAB = 'tab'
export const QUOTES_PAGE_URL_PATH = '/pages/quotes'
export const ORDERS_PAGE_URL_PATH = '/orders'
export const QUOTES_TAB_KEY = '1'
export const SECURE_PLUS_QUOTES_TAB_KEY = '2'
export const ORDERS_TAB_KEY = '3'
export const NEW_INJECTION_MOLDING = 'new-injection-molding'
export const NEW = 'new'

export const getURLParameters = (searchString = '') => {
    const searchParameters = searchString.replace('?', '')
    const urlParams = new URLSearchParams(searchParameters)
    const tabKey = urlParams.get(TAB) || QUOTES_TAB_KEY
    const pageNumber = urlParams.get(PAGE) || '1'

    return {
        tabKey,
        pageNumber,
    }
}

export const getTabKeyFromUrl = (pathname = '', searchString = '') => {
    if (pathname.includes(ORDERS_PAGE_URL_PATH)) {
        return ORDERS_TAB_KEY
    }
    return getURLParameters(searchString).tabKey
}

export const getPathAndQuery = (
    pageNumber = 1,
    tabKey = '1',
    pathname = QUOTES_PAGE_URL_PATH,
): string => {
    const queryData = [
        [PAGE, `${pageNumber}`],
        [TAB, tabKey],
    ]
    const searchParameters = new URLSearchParams(queryData)

    return `${pathname}?${searchParameters.toString()}`
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getQuotes = (props: any) => {
    const { data = {} } = props

    return _.get(data, 'me.quotes.items') || EMPTY_ARRAY
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getQuotesForAdminPage = (data: any) => {
    return data?.user?.quotes?.items || EMPTY_ARRAY
}

export const getTableData = createSelector(
    _.property('quoteModels.items'),
    (quoteModels: QuoteModelsType[] = []) => {
        const tableData: {
            __typename: string
            id: string
            selectedQuoteModelRevision?: SelectedQmrType
        }[] = []

        quoteModels.forEach((item: QuoteModelsType) => {
            tableData.push({
                __typename: item.__typename,
                id: quoteModelRevisionKey(item?.selectedQuoteModelRevision?.id),
                selectedQuoteModelRevision: item?.selectedQuoteModelRevision,
            })
        })
        return tableData
    },
)

export const getOffsetOfFirstAndLastRecord = (
    pageNumber: number | undefined,
    numberOfRecordsonPage: number | undefined,
    paginationLimit: number,
) => {
    const offsetOfFirstRecordOfPage = pageNumber
        ? (pageNumber - 1) * paginationLimit + 1
        : 0
    const offsetOfLastRecordOfPage = numberOfRecordsonPage
        ? offsetOfFirstRecordOfPage + numberOfRecordsonPage - 1
        : 0

    return { offsetOfFirstRecordOfPage, offsetOfLastRecordOfPage }
}

export const checkUserIsQuoteOwner = ({
    quoteOwnerId,
    userId,
}: {
    quoteOwnerId: number
    userId: number
}): boolean => {
    return quoteOwnerId === userId
}

export enum QuoteType {
    im = 'im',
    generic = 'generic',
}
